import {CabCalf} from 'api/gen/CabCalf';

import {AnimalBrowserLinkProps, getAnimalBrowserLink} from './get-animal-browser-link';
import {getBullBrowserLink} from './get-bull-browser-link';

/** Minimal calf row data required to resolve a female or bull browser link. */
export type CalfLinkProps = AnimalBrowserLinkProps & Pick<CabCalf, 'sex'>;

/**
 * Resolves the correct browser link for a calf row based on its sex.
 *
 * @param _id Unused row id required by the table-link callback signature.
 * @param row Calf row with ear-tag, optional HUID, and sex.
 * @returns The female animal-browser link or the bull browser link for the row.
 */
export const getCalfBrowserLink = (
    _id: number | string,
    row: CabCalf | CalfLinkProps,
): string => {
    const {sex} = row;

    return sex === 'FEMALE' ? getAnimalBrowserLink(row) : getBullBrowserLink('earTag')(row);
};
